import { httpsCallable } from 'firebase/functions';
import { functions } from '../../config/firebase-config';
import { notifyPermissionDenied } from '../core/handleCallableError';

export const getTop3OffersPerAuction = async (data) => {
  try {
    const getTop3OffersFn = httpsCallable(
      functions,
      'getTop3OffersPerAuctionNewV2'
    );
    const amounts = await getTop3OffersFn(data);
    return amounts;
  } catch (error) {
    console.error('Error al obtener las mejores ofertas:', error);
    notifyPermissionDenied(error);
    throw error;
  }
};

export const getIfMyOfferIsWinner = async (data) => {
  const getIfMyOfferIsWinnerFn = httpsCallable(
    functions,
    'getIfMyOfferIsWinnerNewV2'
  );
  try {
    const result = await getIfMyOfferIsWinnerFn(data);
    return result.data;
  } catch (error) {
    console.error('Error al verificar si la oferta es ganadora:', error);
    notifyPermissionDenied(error);
    throw error;
  }
};
